import { BookingAges } from 'ts/dynamic/interfaces/DynamicResponse';
import i18n from 'i18next';

export const dynamicSearchTypes = [
  { value: '0', label: 'dyn.predefined' },
  { value: '1', label: 'dyn.self' },
];

export const getPeople = () => {
  return [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
  ];
};

export const cabinTypes = [
  { value: 0, label: 'flight.economy' },
  { value: 3, label: 'flight.economy_premium' },
  { value: 1, label: 'flight.business' },
];

export const searchSubtypes = [
  { value: 'Sport', label: 'dyn.sport' },
  { value: 'Events', label: 'dyn.music' },
];

export const getSortFlightOptions = (dep: string, arr: string) => [
  { value: 'priceIncrease', label: i18n.t('sort.price_increase') },
  { value: 'priceDecrease', label: i18n.t('sort.price_decrease') },
  { value: 'airlineIncrease', label: i18n.t('sort.airline_increase') },
  { value: 'airlineDecrease', label: i18n.t('sort.airline_decrease') },
  { value: 'durationIncrease', label: i18n.t('sort.duration_increase') },
  { value: 'durationDecrease', label: i18n.t('sort.duration_decrease') },
  {
    value: 'departureOutboundIncrease',
    label: i18n.t('sort.departure_outbound_increase', { dep }),
  },
  {
    value: 'departureOutboundDecrease',
    label: i18n.t('sort.departure_outbound_decrease', { dep }),
  },
  {
    value: 'returningOutboundIncrease',
    label: i18n.t('sort.returning_outbound_increase', { arr }),
  },
  {
    value: 'returningOutboundDecrease',
    label: i18n.t('sort.returning_outbound_decrease', { arr }),
  },
  {
    value: 'departureInboundIncrease',
    label: i18n.t('sort.departure_inbound_increase', { arr }),
  },
  {
    value: 'departureInboundDecrease',
    label: i18n.t('sort.departure_inbound_decrease', { arr }),
  },
  {
    value: 'returningInboundIncrease',
    label: i18n.t('sort.returning_inbound_increase', { dep }),
  },
  {
    value: 'returningInboundDecrease',
    label: i18n.t('sort.returning_inbound_decrease', { dep }),
  },
];

export enum PassengerType {
  Adult = 'ADT',
  Senior = 'SRC',
  Child = 'CNN',
  Infant = 'INF',
  Youth = 'YTH',
}

export const getBookingAges = (paxType: string, ages?: BookingAges) => {
  let result = ['0', '120'];
  if (!ages)
    return {
      min: +result[0],
      max: +result[1],
    };
  switch (paxType) {
    case PassengerType.Adult:
      result = ages.ADT;
      break;
    case PassengerType.Child:
      result = ages.CNN;
      break;
    case PassengerType.Infant:
      result = ages.INF;
      break;
    case PassengerType.Senior:
      result = ages.SRC;
      break;
    case PassengerType.Youth:
      result = ages.YTH;
      break;
    default:
      break;
  }

  return {
    min: +result[0],
    max: +result[1],
  };
};

export const getBookingAgesStr = (paxType: string, ages?: BookingAges) => {
  if (!ages) return '';
  switch (paxType) {
    case PassengerType.Adult:
      return '';
    case PassengerType.Child:
      return ages.CNN.join(' - ');
    case PassengerType.Infant:
      return ages.INF.join(' - ');
    case PassengerType.Senior:
      return ages.SRC.join(' - ');
    case PassengerType.Youth:
      return ages.YTH.join(' - ');
    default:
      return '';
  }
};

export const dynAgesList = {
  INF: ['0', '2'],
  CNN: ['2', '12'],
  YTH: ['12', '26'],
  SRC: ['65', '100'],
  ADT: ['18', '100'],
};

export const genderOptions = [
  { value: 'M', label: 'male' },
  { value: 'F', label: 'female' },
];


export const getPaxCountOptions = (maxPaxes: number) =>
  [...Array(maxPaxes)].map((_, index) => ({
    value: index + 1,
    label: (index + 1).toString(),
  }));
